import React from "react"
import { Route, useRouteMatch } from "react-router-dom"

import SubmissionConverterFormInput from "./components/SubmissionConverterForm/SubmissionConverterFormInput"
import SubmissionConverterFormOutput from "./components/SubmissionConverterForm/SubmissionConverterFormOutput"
import SubmissionGridRouter from "./components/SubmissionGrid/SubmissionGridRouter"
import AuditSubmissions from "./containers/AuditSubmissions"
import SectorSubmissionEdit from "./containers/SectorSubmissionEdit"
import SubmissionDetail from "./containers/SubmissionDetail"
import SubmissionEdit from "./containers/SubmissionEdit"
import SubmissionList from "./containers/SubmissionList"
import SubmissionSelection from "./containers/SubmissionSelection"
import SubmissionSelectionConverter from "./containers/SubmissionSelectionConverter"

const Submissions = () => {
  const { path } = useRouteMatch()

  return (
    <>
      <Route exact path={path}>
        <SubmissionList />
      </Route>
      <Route exact path={`${path}/new/:type`}>
        <SubmissionGridRouter />
      </Route>
      <Route exact path={`${path}/new/`}>
        <SubmissionSelection />
      </Route>
      <Route exact path={`${path}/show/:id/convertingInput`}>
        <SubmissionConverterFormInput isDisabled />
      </Route>
      <Route exact path={`${path}/show/:id/convertingOutput`}>
        <SubmissionConverterFormOutput isDisabled />
      </Route>
      <Route exact path={`${path}/show/:id/:type`}>
        <SubmissionDetail />
      </Route>
      <Route exact path={`${path}/edit/:id/:type`}>
        <SubmissionEdit />
      </Route>
      <Route exact path={`${path}/edit/sector/:year`}>
        <SectorSubmissionEdit />
      </Route>
      <Route exact path={`${path}/audit/:companyId`}>
        <AuditSubmissions />
      </Route>

      <Route exact path={`${path}/new-converting/`}>
        <SubmissionSelectionConverter />
      </Route>
      <Route exact path={`${path}/new-converting/:type`}>
        <SubmissionGridRouter />
      </Route>
    </>
  )
}

export default Submissions
